export const WATCHLISTS_LIMIT = 5;
export const WATCHLIST_ITEMS_LIMIT = 50;
